import React from "react"

import * as styles from "./GeneralFormStyles.module.scss"


function InputFormField({ field_name, placeholder, label, is_required, disabled, onChange }) {
  return (
    <div className={styles.formInput}>
      <label htmlFor={field_name}>
        {label}
        {is_required ? (<span>&nbsp;<span className={styles.textGreen}>*</span></span>) : null}
      </label>
      <input
        id={field_name}
        type="text"
        name={field_name}
        required={is_required}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled} />
    </div>
  )
}

function SelectFormField({ field_name, options, label, is_required, disabled, onChange }) {
  return (
    <div className={styles.formInput}>
      <label htmlFor={field_name}>
        {label}
        {is_required ? (<span>&nbsp;<span className={styles.textGreen}>*</span></span>) : null}
      </label>
      <select 
        id={field_name}
        name={field_name}
        required={is_required}
        disabled={disabled}
        onChange={onChange}>
        {options.map((opt, idx)=>{
          if(idx === 0) {
            return <option key={`0_default`} value="">{opt}</option>
          } else {
            return <option key={`${idx}_${opt}`} value={opt}>{opt}</option>
          }
        })}
      </select>
    </div>
  )
}

function CheckboxFormField({ field_name, label, is_required, disabled, onChange }) {
  return (
    <div className={styles.formCheckbox}>
      <input type="checkbox"
        id={field_name}
        name={field_name}
        required={is_required}
        disabled={disabled}
        onChange={onChange} />
      <label htmlFor={field_name}>
        {label}
        {is_required ? (<span>&nbsp;<span className={styles.textGreen}>*</span></span>) : null}
      </label>
      <div style={{clear: "both"}} />
    </div>
  )
}

function ValidateEmail(email) 
{
  if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true
  }
  return false
}

function EncodeFormData(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export {
  InputFormField,
  SelectFormField,
  CheckboxFormField,

  ValidateEmail,
  EncodeFormData
}